import { z } from 'zod';

export const TenantMembershipRole = z.enum([
  'superuser',
  'admin',
  'approver',
  'creator',
  'viewer',
]);

export type TenantMembershipRole = z.infer<typeof TenantMembershipRole>;

export const TenantMembership = z.object({
  id: z.number(),
  account_id: z.uuidv4(),
  tenant_id: z.number(),
  role: TenantMembershipRole,
  created_at: z.iso.datetime(),
  archived_at: z.iso.datetime().nullable(),
});

export type TenantMembership = z.infer<typeof TenantMembership>;
